module.exports = __webpack_public_path__ + "static/codrops-2d7b2a1fab472ef02babd2186b76f4d8.png";